import dayjs from "dayjs";
import { getFormattedRecords } from "../MarketingPage/utils";
import { getRecentReleases } from "../MarketingPage/Components/SuperboostModal/api";
import { CurrentBrand } from "modules/Types";

/**
 * Type for default date options
 */
export type DATE_OPTIONS = 'last-7-days' | 'last-30-days' | 'last-3-months' | 'custom' | 'all-time'

/**
 * Returns a start and end date based on a given range
 * @param range 
 * @returns startDate and endDate, formatted as "YYYY-MM-DD"
 */
export function getDatesByRange(range: DATE_OPTIONS): {
    startDate: string;
    endDate: string;
} {
    const today = dayjs()
    switch (range) {
        case 'last-7-days':
            return {
                startDate: today.subtract(7, 'day').format("YYYY-MM-DD"),
                endDate: today.format("YYYY-MM-DD")
            }

        case 'last-30-days':
            return {
                startDate: today.subtract(30, 'day').format("YYYY-MM-DD"),
                endDate: today.format("YYYY-MM-DD")
            }
        case 'last-3-months':
            return {
                startDate: today.subtract(90, 'day').format("YYYY-MM-DD"),
                endDate: today.format("YYYY-MM-DD")
            }
        case 'custom':
            return {
                startDate: today.subtract(30, 'day').format("YYYY-MM-DD"),
                endDate: today.format("YYYY-MM-DD")
            }
        case 'all-time':
            return {
                startDate: today.subtract(5, 'year').format("YYYY-MM-DD"),
                endDate: today.format("YYYY-MM-DD")
            }
    }
}

export async function getSpotifyReleaseData(props: {
    currentBrand: CurrentBrand;
}) {
    const {
        currentBrand
    } = props

    const { data } = await getRecentReleases(currentBrand)

    const formattedData = getFormattedRecords({
        recentReleases: data || [],
        releaseType: 'project',
        search: ''
    })

    return formattedData;
}

